module.exports = __webpack_public_path__ + "static/media/heroledger-background-store.83fe897f.jfif";